<template>
  <v-container fluid grid-list-lg>
    <v-layout wrap>
      <v-flex pt-20 class="pt-7">
        <span
          class="display-2 font-weight-light "
          v-bind:class="moveTitleClassObject"
          >Guía del usuario
        </span>
      </v-flex>

      <v-flex shrink> </v-flex>
      Guía del usuario
    </v-layout>
    <v-divider></v-divider>

    <!--   <v-alert
      icon="mdi-shield-lock-outline"
      prominent
      border="left"
      text
      type="info"
    >
      Haga click en <v-icon color="info" small>mdi-settings</v-icon> para
      cambiar la velocidad y las opciones de navegación.
    </v-alert>
 -->
    <v-layout wrap>
      <v-flex xs12>
        <v-card :elevation="0">
          <v-card-text>
            <p class="title font-weight-light">
              Bienvenido a la Guía del usuario de PacReport. Elija un tema de la
              izquierda para resolver sus dudas, obtener instrucciones paso a
              paso y desarrollar sus habilidades en el uso de esta herramienta.
            </p>
            <v-alert
              icon="mdi-shield-lock-outline"
              prominent
              border="left"
              text
              color="primary"
            >
              En caso de no encontrar la ayuda que necesita en esta Guía por
              favor contáctese con nuestro especialista a la dirección de correo
              <a>soporte@pac.report</a>
            </v-alert>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card :elevation="0">
          <v-toolbar dense :elevation="0" color="background darken-1">
            <v-toolbar-title>Introducción</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <div class="title">¿Qué es PacReport?</div>
            <p>
              {{
                $Amplify.I18n.get(
                  `is the business intelligence solution for public purchases with which you can explore the purchasing plans of the contracting entities, allowing you to analyze the supply and demand existing in the public sector in the simplest and most practical way you have ever imagined, helping you to identify business opportunities and to empathize with the competitive dynamics of public purchases.`
                )
              }}
            </p>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card :elevation="0">
          <v-toolbar dense :elevation="0" color="background darken-1">
            <v-toolbar-title>Filtros</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <div class="title">Qué es un filtro</div>
            <p>
              Los filtros son la parte más importante de PacReport, ya que estos
              nos permiten realizar consultas sobre los datos almacenados en su
              espacio de información, por lo que entender su funcionamiento le
              ayudará a obtener mejores resultados en su busqueda de
              información.
            </p>
            <p>
              Al igual que los filtros de Microsoft Excell o cualquier otro
              programa de Hoja de Cálculo, un fitro se aplica sobre una columna
              y solo se permite agregar un filtro por columna
            </p>

            <p>
              De forma predeterminada, PacReport ordena los resultados de
              búsqueda por valor desde el más alto al más bajo.
            </p>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card :elevation="0">
          <v-toolbar dense :elevation="0" color="background darken-1">
            <v-toolbar-title>Consultas</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <div class="title">Qué es una Consulta</div>
            <p>
              Una consulta está confomada por uno o más filtros y se pueden
              guardar para ser usadas posteriormente sin la necesidad de tener
              que volver a crear los filtros
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Help",
  components: {},
  data() {
    return {};
  },
  computed: {
    moveTitleClassObject: function() {
      return {
        "ml-12": !this.$store.getters.dashboardDrawer
      };
    }

    //itemsJSON: function() {
    //return this.$store.getters.pacs;
    //}
  },
  methods: {},
  async mounted() {}
};
</script>
